import { createContext, useContext } from 'react';

export interface CollapsibleGroupContextType {
  expandedId: string | null;
  toggleExpanded: (id: string) => void;
  setExpandedId: (id: string | null) => void;
  /** Keeps an item expanded and prevents collapsing it until unlocked. */
  setExpandedLocked: (id: string, locked: boolean) => void;
}

export const CollapsibleGroupContext = createContext<CollapsibleGroupContextType | null>(null);

export const useCollapsibleGroup = () => {
  const context = useContext(CollapsibleGroupContext);
  return context;
};
